module.exports = __webpack_public_path__ + "static/media/SetupChecknew.e37991a5.svg";